import React, { createContext, useContext, useEffect, useReducer, useState } from 'react'
import { client } from '../utils';
import { UserContext } from '../Component/User/UserContext';
import  {getSlabStock} from "./General"; 
import { toast,ToastOptions } from 'react-toastify';
import { roundOff } from './General';
export const CartContext = createContext();
export const CartContextProvider = (props) => {
    const {Userinfo}=useContext(UserContext);
    const [existcarts,setexistcarts]=useState([]);
    const [cartloaded,setcartloaded]=useState(false);
    const [cartprocessing,setcartprocessing]=useState(false);
    const [clickid,setclickid]=useState(0);
    const [cartcontextrefresh,setcartcontextrefresh]=useState(false);
    const [stockavailchecking,setstockavailchecking]=useState(false);
    useEffect(()=>{
     if (Userinfo.uuid !='')  getAddedCartitems();
    },[Userinfo.uuid])
  //  const [cart,dispatcher] = useReducer(CartReducer,existcarts)
    const getAddedCartitems= async (checklivestock)=>
    {
      setcartloaded(true);
      //return await  client('/api/carts?filters[uuid]=' + Userinfo.uuid + '&sort[0]=id:asc' ,{})
      return await  client('/api/cart/fetchcartlist' ,{headers:{uuid:Userinfo.uuid}})
           .then(async(x)=>{
             x.totalQty=x.reduce(function(prev, current) { return prev + + current.attributes.qty }, 0);
             x.totalaPrice = x.reduce(function(prev, current) { return prev + + (current.attributes.price * current.attributes.qty) }, 0);
             x.totaldiscount=x.reduce(function(prev, current) { return prev + + (current.attributes.discount * current.attributes.qty)   }, 0);
             x.totalPrice = x.reduce(function(prev, current) { return prev + + current.attributes.totalprice }, 0);
             x.totalaPrice =roundOff(x.totalaPrice,2);
             x.totaldiscount=roundOff(x.totaldiscount,2);
             x.totalPrice= roundOff((x.totalPrice),2) ; 
             x.totalvatamt =roundOff(((x.totalPrice * 5 ) / 100 ),2);
             x.netamt =roundOff( (x.totalPrice + x.totalvatamt),2);
             setexistcarts(x)
             setcartloaded(false);
             if (checklivestock===true) checkcartstock(x);
             return x
           })
           .catch((y)=>{
            setcartloaded(false);
            setexistcarts([]);
           })
           //
           
     }
     const checkpricechange =async ()=>{
      try
      {
          let pricechangefound=false;
          await Promise.all(existcarts.map( async (x)=>{
                 await client('/api/inventory/getdetails',{headers:{matnr:x.attributes.matnr,slabid:x.attributes.slabid}})
                 .then((s)=>{
                      if ((x.attributes.price != s[0].price) || (x.attributes.discount != s[0].discount) ){
                         x.attributes.pricechanged=true;
                         client('/api/carts/' + x.id,{body:{data:{
                          price:s[0].price,
                          discount:s[0].discount,
                          totalprice:roundOff(x.attributes.qty * roundOff((s[0].price - s[0].discount),2),2)
                         }},method:"PUT"})
                         .then((uc)=>{ })
                         .catch((ucex)=>{ })
                          pricechangefound=true;
                       }
                   })
                 .catch((e)=>{
                 
                 })
                
               } ))
          if (pricechangefound===true){ await getAddedCartitems();}
          return pricechangefound;
      }
      catch (ex){
        return false;
      }
     }
     const checkcartstock =async (_existcarts)=>{
      try
      {
          let stockshort=false;
          setstockavailchecking(true)
          if (_existcarts===undefined || _existcarts===null){_existcarts= await getAddedCartitems();}
          var cartobj=await Promise.all(_existcarts.map( async (x)=>{
                 await getSlabStock(x.attributes.slabid,x.attributes.matnr)
                 .then((s)=>{
                       x.attributes.availqty=0;
                      if (x.attributes.qty > s[0]?.availqty){//checking stock availability
                         x.attributes.stockshort=true;
                         x.attributes.availqty=s[0].availqty;
                         stockshort=true;
                       }
                       else if (s[0]?.retailprice!=x.attributes.price || s[0]?.discount.trim()!=x.attributes.discount) //checking price change
                       {
                        stockshort=true;
                        x.attributes.pricechangefound=true;
                        x.attributes.availqty=s[0]?.availqty;
                       }
                       else if (roundOff((x.attributes.qty * (s[0]?.retailprice - s[0]?.discount)),2) != x.attributes.totalprice) //checking price change
                       {
                        stockshort=true;
                        x.attributes.pricechangefound=true;
                        x.attributes.availqty=s[0]?.availqty;
                       }
                       else {
                       // x.attributes.stockshort=true;
                        x.attributes.availqty=s[0]?.availqty; 
                        //stockshort=true;
                      }
                   })
                 .catch((e)=>{
                  x.attributes.stockshort=true;
                  x.attributes.availqty=0;
                  stockshort=true;
                  console.log(e);
                 })
               } ))
          setexistcarts(_existcarts);
          setstockavailchecking(false)
          return stockshort;
      }
      catch (ex){
        setstockavailchecking(false);
        return false;
      }
     }
     const AddtoCart= async (action) =>{
        setcartprocessing(true);
        setclickid(action.id);
        let products= action.product;
        var Userinfo=action.Userinfo;
        let check;
        let cart=await getAddedCartitems();
        check =cart.find(product => product.attributes.slabid == action.id 
          && product.attributes.matnr == action.product.matnr );
             if (check) {
                 toast.info('This product is already in your cart',{ position:'bottom-right',theme:'colored' });
                 setcartprocessing(false);
                 return;
                 }
            //var stock = await getSlabStock(products.slabid,products.matnr);
             //add to cart---availqty
             //if (Number(stock[0]?.availqty) >= action.qty)
             if (Number(products.availqty) >= action.qty)
             {
             products.totalprice =roundOff((products.retailprice - products.discount)  * action.qty,2);
             await client('/api/carts',
             {  body: {data: { 
                user:Userinfo?.Email,
                matnr:products.matnr,
                slabid:products.slabid,
                qty:action.qty,
                price:products.retailprice,
                discount:products.discount, 
                totalprice:products.totalprice,
                desc:products.maktx,
                uuid:Userinfo?.uuid,
                uom:products.meins,
                slabdesc:products.slabdesc,
                availablestock:products.availqty,
            } }})
            .then(async  (x)=>{await getAddedCartitems();toast.success('Item added to the cart',{ position:'bottom-right',theme:'colored' });})
            .catch((y)=>{toast.error("Oops!something went wrong!");})
             setcartprocessing(false);
            }
            else 
              {
              toast.info("The stock is less than your added Qty",{ position:'bottom-right',theme:'colored' });
              setcartprocessing(false);
              }
             //-------------
    }
    const Deletefromcart= async (action) =>{
        setcartprocessing(true);
        setclickid(action.pkey+'dl');
        await client('/api/carts/' + action.pkey,{method:"DELETE"})
            .then(async (x)=>{
               toast.success('Removed from the cart',{ position:'bottom-right',theme:'colored' });
               await getAddedCartitems();
               setcartprocessing(false);
            })
            .catch((y)=>{
                toast.error("Oops!something went wrong!");
                setcartprocessing(false);
            })
    }
const Deletecart= async () => {
            existcarts.map((cart,index)=>{
            client('/api/carts/' + cart.id,{method:"DELETE"})
               .then(async(x)=>{
                 await getAddedCartitems();
               })
               .catch((y)=>{
               })
            })

       }

const checkproductsarepublished= async () => {
        let items='';
        existcarts.map((cart,index)=>{
          items=items + `'` +  cart.attributes.matnr + `',`;
        })
       return client('/api/products/checkproductsarepublished',{ headers:{ items:items.substring(0,items.length-1) } })
        .then(x=>{ 
          return x;
        })
        .catch(y=>{
          console.log(y);
          return {msg:'something went wrong!'}
         })
       
   }      
    const Updatecart=async (action) =>{
        let products= action.cart;
        var Userinfo=action.Userinfo;
        if (products.attributes.qty==="0" || products.attributes.qty==='' ) { toast.warning('you cannot update zero quantity!',{ position:'bottom-right',theme:'colored' });return;  }
        if (products.attributes.qty < 0 ) { toast.warning('Quantity cannot become negative value!',{ position:'bottom-right',theme:'colored' });return;  }
        if (products.attributes.qty===1 && action.type==='DEC'){return;  }
        setcartprocessing(true);
        setclickid(action.pkey);
        var stock=await getSlabStock(products.attributes.slabid,products.attributes.matnr)
        if (Number(stock[0]?.availqty) >=( (action.type==='UPDT') ? products.attributes.qty : (action.type==='INC') ? (products.attributes.qty + 1) : (products.attributes.qty - 1)))
         {
            client('/api/carts/' + action.pkey,{
            body: {data: { 
                user:Userinfo.Email,
                matnr:products.attributes.matnr,
                slabid:products.attributes.slabid,
                price:products.attributes.price,
                qty:(action.type==='UPDT') ? products.attributes.qty : (action.type==='INC') ? products.attributes.qty + 1 : products.attributes.qty - 1,
                totalprice:roundOff( (products.attributes.price - products.attributes.discount)  * ((action.type==='UPDT') ? products.attributes.qty : (action.type==='INC') ? ++products.attributes.qty : --products.attributes.qty),2),
                desc:products.attributes.desc,
                uuid:Userinfo.uuid,
                discount: products.attributes.discount
            } }   ,method:"PUT"})
            .then(async (x)=>{await getAddedCartitems();toast.success('Cart updated',{ position:'bottom-right',theme:'colored'});})
            .catch((y)=>{ toast.error("Oops!something went wrong!");})
             setcartprocessing(false);
            //----------------
         }
         else {
            toast.info("The available stock is less than your updating Qty , InStock : " + stock[0]?.availqty ,{ position:'top-center',theme:'colored' });
            products.attributes.availqty=stock[0]?.availqty;
            setcartprocessing(false);
         }

    
    }
return (
        <CartContext.Provider value={{ shoppingCart:existcarts,getAddedCartitems,cartloaded,
            AddtoCart,Deletefromcart,Updatecart,cartprocessing,clickid,checkpricechange,Deletecart,
            checkcartstock,stockavailchecking,setstockavailchecking,setexistcarts,checkproductsarepublished,setcartcontextrefresh}}   >
            {props.children}
        </CartContext.Provider>
    )
}